module.exports = __webpack_public_path__ + "media/images/hono16-3c1703d9c02211fd3cd8df19114b965f.ico";